import { forwardRef, createElement } from 'react';
import cn from 'classnames';
import { IconButton } from '../IconButton/IconButton.js';
import { useLocalization } from '../Provider/Provider.js';
import { Calendar } from '../Calendar/Calendar.js';
import { Input } from '../Input/Input.js';
import { useDatepicker } from './useDatepicker.js';
import { Popover } from '../Popover/Popover.js';

const Datepicker = /*#__PURE__*/forwardRef(function Datepicker(props, ref) {
  const {
    className: externalClassName,
    onReset: handleReset,
    style,
    shortcuts,
    shortcutsText,
    ...otherProps
  } = props;
  const {
    calendar,
    input
  } = useDatepicker(otherProps, ref);
  const {
    texts
  } = useLocalization();
  const className = cn('inline-flex w-full text-black font-normal', externalClassName);
  return createElement("span", {
    className: className,
    "data-taco": "datepicker",
    style: style
  }, createElement(Input, Object.assign({}, input, {
    button: createElement(Popover, null, createElement(Popover.Trigger, null, createElement(IconButton, {
      "aria-label": texts.datepicker.expand,
      disabled: input.disabled || input.readOnly,
      icon: "calendar"
    })), createElement(Popover.Content, null, ({
      close
    }) => createElement("div", {
      className: "-m-3 flex"
    }, createElement(Calendar, Object.assign({}, calendar, {
      onChange: (date, event) => {
        calendar.onChange(date, event);
        close();
      },
      tabIndex: -1
    })), shortcuts && createElement("div", {
      className: "border-grey-dark flex flex-col border-l"
    }, createElement("span", {
      className: "m-4 mb-3 flex h-8 w-32 items-center text-xs font-semibold"
    }, shortcutsText !== null && shortcutsText !== void 0 ? shortcutsText : texts.datepicker.shortcuts), createElement("ul", null, shortcuts.map((shortcut, i) => createElement("li", {
      key: i
    }, createElement("button", {
      className: "hover:bg-grey-light flex w-full items-start px-4 py-1 text-xs",
      onClick: event => {
        event.persist();
        shortcut.onClick(event);
        close();
      }
    }, shortcut.text)))), handleReset && createElement("button", {
      className: "text-blue hover:text-blue-light my-4 mx-auto mt-auto inline-flex cursor-pointer border-none bg-transparent text-xs",
      onClick: event => {
        event.persist();
        handleReset(event);
        close();
      }
    }, texts.datepicker.clear)))))
  })));
});

export { Datepicker };
//# sourceMappingURL=Datepicker.js.map
